import { call, put } from 'redux-saga/effects';
import { setMarkets, setMarketsFetching } from './actions';

import { fetchMarkets } from '../../api/markets';
import { Market } from '../../api/markets.types';

export function* getMarkets() {
  yield put(setMarketsFetching(true));
  const markets: Market[] = yield call(fetchMarkets);
  yield put(setMarkets(markets));
  yield put(setMarketsFetching(false));
}
